import React from 'react';
import { ReactComponent as Check } from 'images/StepperComponent/Check.svg';
import { StepIconRoot } from './styles';

export const StepIcon = (props) => {
  const { active, completed, className, icon } = props;
  return (
    <StepIconRoot
      ownerState={{ active, completed }} className={className}>
      {completed
        ? (
          <Check
            className='StepIcon-completedIcon'
          />
        )
        : (
          <div
            className='StepIcon-stepNumber'>{icon}</div>
        )}
    </StepIconRoot>
  );
};
